<template>
	<div class="table">
    <br/>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item><i class="el-icon-lx-cascades"></i><b>报警处理记录</b></el-breadcrumb-item>
			</el-breadcrumb>
		</div>
    <br/>
		<el-form ref="form" :model="form" label-width="90px">
			<el-row>
				<el-col :span="3">
					<el-form-item label="报警人姓名:">
						<!--设置ref,使用 ref 属性来标识一个元素,方便在后面的时候获取输入的值-->
<!--						<el-input v-model="form.warningName" placeholder="报警人姓名" ref="warningName"></el-input>-->
            <span>{{form.warningName}}</span>
					</el-form-item>
				</el-col>
				<el-col :span="3">
					<el-form-item label="报警人电话:">
						<!--设置ref,使用 ref 属性来标识一个元素,方便在后面的时候获取输入的值-->
<!--						<el-input v-model="form.warningPhone" placeholder="报警人电话" ref="warningPhone"></el-input>-->
            <span>{{form.warningPhone}}</span>
					</el-form-item>
				</el-col>
<!--				<el-col :span="3">-->
<!--					<el-form-item label="处理人:">-->
<!--						&lt;!&ndash;设置ref,使用 ref 属性来标识一个元素,方便在后面的时候获取输入的值&ndash;&gt;-->
<!--&lt;!&ndash;						<el-input v-model="form.dealManagerName" placeholder="处理人" ref="dealManagerName"></el-input>&ndash;&gt;-->
<!--            <span>{{this.form.dealManagerName}}</span>-->
<!--					</el-form-item>-->
<!--				</el-col>-->

			</el-row>
		</el-form>


		<br/>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item><i class="el-icon-lx-cascades"></i>处理记录</el-breadcrumb-item>
		</el-breadcrumb>

		<el-table :data="tableData" border class="table" header-align="center" >

			<el-table-column prop="dealPass" label="处理经过" width="800"  >
			</el-table-column>
			<el-table-column prop="dealTime" label="处理时间" width="150" :formatter="dateFormat" >
			</el-table-column>
      <el-table-column prop="dealManagerName" label="处理人" width="120"  >
      </el-table-column>
			<el-table-column prop="dealResult" label="处理结果" width="100" >
				<template slot-scope="scope">
					<span v-if="scope.row.dealResult===1">未处理</span>
					<span v-if="scope.row.dealResult===2">处理中</span>
					<span v-if="scope.row.dealResult===3">处理完成</span>
				</template>
			</el-table-column>

		</el-table>


	</div>
</template>

<script>
  import store from '../../store'
	export default {
		data() {
			return {
				tableData: [],
        form :{
          warningName: '',
          warningPhone: ''
        }
			}
		},
		created() {
      this.$post('pc_warning/getWarningDealRecord',{
        warningId: this.$route.query.id,
      }).then((res) => {
				//console.log(res)
				this.tableData = res.data.data;
// 				console.log(res.data.data.list.warningName);
// 				this.form.warningName = res.data.data.data.warningName;
				if(this.tableData!==null && this.tableData!=="" && this.tableData.length>0){
					//因为同一条报警信息，即使有多条处理记录，但报警人和电话在多条记录中信息都是一样的，所以下面this.tableData[i] 中的i可以为i ，
					//也可以为第一个，因为处理记录最少有一条，因此此处可写0或i
					this.form.warningName =this.tableData[0].warningName
					this.form.warningPhone =this.tableData[0].warningPhone
				}

			}).catch((error) => {
				console.log(error)
			})

		},
		methods: {

			formatter(row, column) {
				return row.address;
			},
			filterTag(value, row) {
				return row.tag === value;
			},


			//格式转换，直接复制即可
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => v[j]))
			},
			formatState(row, column) {
				return row.state == '1' ? "有效" : row.state == '0' ? "失效" : "秘密";
			},
			//时间格式化
			dateFormat: function(row, column) {
				var ut = row[column.property];
				var t = new Date(ut);
				return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate() + " " + t.getHours() + ":" + t.getMinutes() +
					":" + t.getSeconds();
			},
			//状态格式化
			stateFormat(row, column) {
				return row.state ===1 ? "正常" : row.state ===0 ? "风险用户" : "未知";
			},

		},
	}
</script>

<style scoped>
	.form-box {
		width: 60.5rem;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.del-dialog-cnt {
		font-size: 16px;
		text-align: center
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/views/warning/WarningDealInfo.vue